import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { DrawerTopBarWithAction } from "@/components/Drawer/DrawerTopBar";
import { SwipeableDrawer } from "@/components/Drawer/SwipeableDrawer";
import type { StopsOptions } from "@/features/flights/types/types";

import { StopsFilter } from "./flight-filters/StopsFilter";

type Props = {
  open: boolean;
  defaultValue?: StopsOptions;
  value?: StopsOptions;
  onSubmit: (newValue?: StopsOptions) => void;
  onClose: () => void;
};

export const StopsFilterDrawer = ({
  open,
  defaultValue,
  value,
  onSubmit,
  onClose,
}: Props) => {
  const intl = useIntl();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <DrawerTopBarWithAction
        onCloseClick={onClose}
        title={intl.formatMessage({ id: "flights.stops" })}
        actionElement={
          <Button
            onClick={() => {
              onSubmit(defaultValue);
            }}
            variant="text"
            size="small"
          >
            {intl.formatMessage({ id: "clearFilter" })}
          </Button>
        }
      />

      <div className="mt-4">
        <StopsFilter value={value} onChange={onSubmit} />
      </div>
    </SwipeableDrawer>
  );
};
